import React from "react";
import glamora from "../assets/case-studies/glamora-cs.png";

export default function GlamoraCaseStudy() {
  return (
    <div className="cs-pages">
      <img src={glamora} alt="Glamora" width="80%" />
    </div>
  );
}
